{
    "TITLE": "Portal de Métodos de Verificación X",
    "WELCOME": "Bem-vindo",
    "PASSWORD": "Senha",
    "LOGIN": "Login",
    "LANGUAGE": "Linguagem",
    "DASHBOARD": "Painel de Pedidos",
    "USER": "Usuário",
    "LOGOUT": "Sair",
    "MENU": "Menu",
    "FILTER": "Filtro",
    "SIESPNUMBER": "SIESPX #",
    "TYPE": "Tipo",
    "NAME": "Nome",
    "FIRSTLASTNAME": "Primeiro Sobrenome",
    "SECONDLASTNAME": "Segundo Sobrenome",
    "STATUS": "Status",
    "STARTOFRESEARCH": "Início da Pesquisa",
    "RESULT": "Resultado",
    "NEWREQUEST": "Nova Solicitação",
    "CREATEREQUEST": "Criar Solicitação",
    "BACK": "De Volta",
    "MAINPERSON": "Informações Pessoais",
    "REFERENCES": "Referências",
    "OTHERRELATIVES": "Outros Parentes",
    "JOBS": "Empregos",
    "GENERALINFORMATION": "Informações Gerais",
    "DIVISION": "Divisão",
    "REQUIREDFIELD": "Campo Obrigatório",
    "LASTNAME": "Sobrenome",
    "ADDRESS": "Endereço",
    "COUNTRY": "País",
    "STATE": "Estado",
    "CITY": "Cidade",
    "STREET": "Rua",
    "POSTALCODE": "Código Postal",
    "BIRTHDATA": "Dados de Nascimento",
    "BIRTHCOUNTRY": "País de Nascimento",
    "BIRTHSTATE": "Estado de Nascimento",
    "BIRTHCITY": "Cidade natal",
    "BIRTHDATE": "Data de Nascimento",
    "RELATIVES": "Parentes",
    "FATHER": "Pai",
    "OCCUPATION": "Ocupação",
    "MOTHER": "Mãe",
    "UNKNOWN": "Desconhecido",
    "CANDIDATETYPE": "Tipo de Candidato",
    "SELECTCANDIDATETYPE": "Selecione o tipo de candidato",
    "CANCEL": "Cancelar",
    "CONTINUE": "Continuar",
    "ADDRELATIVE": "Adicionar Parente",
    "SEARCHINTABLE": "Pesquisar na tabela",
    "ACTIONS": "Ações",
    "ADDJOB": "Adicionar Trabalho",
    "COMPANY": "Empresa",
    "POSITION": "Posição",
    "STARTDATE": "Data de Início",
    "ENDDATE": "Data de Rescisão",
    "ISACTIVE": "Está ativo?",
    "AGE": "Idade",
    "ADDREFERENCE": "Adicionar Referência",
    "MARITALSTATUS": "Estado Civil",
    "NATIONALIDENTITYTYPE": "Tipo de Identificação Nacional",
    "NATIONALID": "Id Nacional",
    "NUMBER": "Número",
    "COLOGNE": "Colônia",
    "NOTES": "Notas",
    "SAVE": "Manter",
    "SELECTOPTION": "Selecione uma opção",
    "GENDER": "Gênero",
    "TAXNUMBERTYPE": "Tipo de Número Fiscal",
    "TAXID": "Número Fiscal",
    "ENTERTAXID": "Insira o Número Fiscal",
    "SOCIALTYPEID": "Tipo de Segurança Social",
    "SOCIALID": "Número da Segurança Social",
    "ENTERSOCIALID": "Insira o número do seguro social",
    "ENTERNAME": "Digite o nome",
    "ENTERFIRSTLASTNAME": "Digite o primeiro sobrenome",
    "ENTERSECONDLASTNAME": "Digite o segundo sobrenome",
    "ENTERBIRTHDATE": "Insira a data de nascimento",
    "ENTERCOMMENT": "Insira um comentário",
    "COMMENTS": "Comentários",
    "ENTERNATIONALID": "Insira o número de identificação nacional",
    "ENTERSTREET": "Entre na rua",
    "ENTERINTNUMBER": "Digite o número interno",
    "ENTEREXTNUMBER": "Digite o número externo",
    "ENTERSUBLOCALITY": "Entre na colônia",
    "ENTERPOSTALCODE": "Digite o CEP",
    "INTNUMBER": "Número Interno",
    "EXTNUMBER": "Número Externo",
    "SPOUSE": "Cônjuge",
    "RELATIVE": "Familiar",
    "SCHOOLING": "Escolaridade",
    "PROFESSION": "Profissão",
    "ENTERPROFESSION": "Entre na profissão",
    "RELATIVETYPE": "Tipo de Família",
    "ADD": "Adicionar",
    "EDIT": "Editar",
    "CONFIRMATION": "Confirmação",
    "SECURITY": "Segurança",
    "PLEASEENTERSECURITYCODE": "Por favor, insira o código de autenticação enviado para o seu dispositivo.",
    "MFACODE": "Código MFA",
    "VALIDATE": "Validar",
    "EDITRELATIVE": "Editar Familiar",
    "EDITJOB": "Editar Trabalho",
    "ENTERCOMPANYNAME": "Digite o nome da empresa",
    "ENTERPOSITIONNAME": "Digite o nome da posição",
    "ENTERSTARTDATE": "Insira a data de início",
    "ENTERENDDATE": "Insira a data de término",
    "ENTERAGE": "Insira a idade",
    "EDITREFERENCE": "Editar Referência",
    "DELETE": "Eliminar",
    "PROGRESS": "Progresso",
    "LOADING": "Carregando",
    "SENDTOSIES": "Enviar para SIES",
    "COMPLETEDPROGRESS": "Progresso de conclusão",
    "SENT": "Em Pesquisa",
    "EXPIRATIONDATE": "Data de Validade",
    "SEEREQUEST": "Veja aplicação",
    "SEND": "Enviar",
    "COMPLETED": "Preenchido",
    "SEERESULT": "Ver resultado",
    "SEMAPHORE": "Semáforo",
    "REQUEST": "Aplicativo",
    "CLOSE": "Fechar",
    "REPORTS": "Informes",
    "DOWNLOADREPORT": "Descargar Informe",
    "SELECTDATESRANGE": "Selecione o Intervalo de Datas",
    "NODATAMATCHING": "Nenhum dado correspondente ao filtro",
    "DOWNLOADPROCESSEDREQUESTREPORT": "Baixar relatório de solicitações processadas",
    "EVIDENCES": "Evidências",
    "RESUBMIT": "Reenviar",
    "SELECTALL": "Selecionar tudo",
    "DOWNLOADRESULT": "Baixar Resultado",
    "RESEARCHMENTRESULT": "Resultado da Pesquisa",
    "IMAGEVIEWER": "Visualizador de Imagens",
    "VIEWIMAGE": "Ver Imagem",
    "FOCUSREQUIREDFIELDS": "Focar campos ausentes",

    "_AMcomment": "From here, there are data base values ^_~",

    "Operativo": "Operacional",
    "Administrativo": "Administrativo",
    "INCOMPLETE": "Incompleto",
    "READY": "Pronto para enviar"
}